import { ApiClient, createApi, localStorageTokenStore } from '@4zen/api-client';

const baseUrl =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';

/** Set by the auth store so a hard 401 can bounce the user to /login. */
let unauthorizedHandler: (() => void) | null = null;

export function onUnauthorized(handler: () => void): void {
  unauthorizedHandler = handler;
}

export const tokenStore = localStorageTokenStore();

export const http = new ApiClient({
  baseUrl,
  tokens: tokenStore,
  platform: '__TAURI_INTERNALS__' in globalThis ? 'desktop' : 'web',
  onUnauthorized: () => unauthorizedHandler?.(),
});

export const api = createApi(http);

export type { TaskFilters } from '@4zen/api-client';

export function websocketUrl(token: string): string {
  const explicit = import.meta.env.VITE_WS_URL as string | undefined;
  if (explicit) return `${explicit}?token=${encodeURIComponent(token)}`;
  const origin = new URL(baseUrl, window.location.origin);
  const protocol = origin.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${origin.host}${origin.pathname.replace(/\/$/, '')}/ws?token=${encodeURIComponent(token)}`;
}
